export namespace AppSettingsModel {
  export interface AppSettings {
    printerBluetoothMacAddress?: string;
    transferPackingLastMethod?: string;
    transferVentilationLastMethod?: string;
    printerServiceAddress?: string;
  }
}
